module.exports = __webpack_public_path__ + "static/oyo-5a21244e562d99c491c4b422fdce45c8.png";